import { Input } from 'antd'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import clsx from 'clsx'
import React from 'react'

import styles from './pure-input.module.scss'

type InputProps = {
  style?: any
  // TODO fix
  value: any
  label?: string
  placeholder?: string
  colClass?: string
  moduleStyle?: string
  icon?: React.ReactNode
  name?: string
  error?: string | string[]
  required?: boolean
  size?: SizeType
  type?: string
  className?: string
  disabled?: boolean
  onInput?: (value: any) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const PureInput: React.FC<InputProps> = ({
  value,
  placeholder,
  label,
  colClass,
  moduleStyle,
  icon,
  error,
  required = true,
  size = 'middle',
  className = '',
  onInput,
  type = 'text',
  ...rest
}) => {
  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.inputStyles, className)}>
      {label ? (
        <div className="label d-block mt-2 mb-1 fs-6">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}
      <Input
        onInput={onInput}
        placeholder={placeholder}
        size={size}
        status={error ? 'error' : ''}
        suffix={icon}
        type={type}
        value={value}
        {...rest}
      />
      {error ? <div className="error-message">{error}</div> : null}
    </div>
  )
}
